class Helpers {
    static formatMoney(amount, decimals = 2) {
        return new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            minimumFractionDigits: decimals
        }).format(amount);
    }

    static validateNumber(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }
} 